import { useFocusEffect, useLocalSearchParams } from 'expo-router'
import { useCallback, useRef, useState } from 'react'
import { ScrollView } from 'react-native'

import FosterHealthCard from '@/components/fosters/cards/FosterHealthCard'
import MedicationChangeModal from '@/components/fosters/cards/medications/MedicationChangeModal'
import { useFosterFormContext } from '@/components/fosters/FosterFormContext'
import FosterTab from '@/components/fosters/FosterTab'
import useFosterOwner from '@/hooks/useFosterOwner'
import { useAppStore } from '@/store/useAppStore'
import { AppTourKeys } from '../../../../../../../constants'

const FosterMedicalTab = () => {
  const { id: fosterId } = useLocalSearchParams<{ id: string }>()
  const { control, formState, setValue } = useFosterFormContext()
  const isFosterOwner = useFosterOwner(fosterId)

  const appTour = useAppStore.use.appTour()
  const setAppTourStepComplete = useAppStore.use.setAppTourStepComplete()

  const currentOrganization = useAppStore.use.currentOrganization().organization
  const isDisabled = !currentOrganization?.subscriptionActive || !isFosterOwner

  const scrollRef = useRef<ScrollView>(null)
  const [isMedicationModalVisible, setMedicationModalVisible] = useState(false)

  const hasCompletedHealthTour = appTour[AppTourKeys.FosterHealthTab]
  const hasSeenMedicationChangeModal =
    appTour[AppTourKeys.MedicationChangeModal]

  useFocusEffect(
    useCallback(() => {
      if (hasCompletedHealthTour && !hasSeenMedicationChangeModal) {
        setMedicationModalVisible(true)
      } else {
        setMedicationModalVisible(false)
      }
    }, [hasCompletedHealthTour, hasSeenMedicationChangeModal])
  )

  const handleDismissMedicationModal = () => {
    setMedicationModalVisible(false)
    setAppTourStepComplete(AppTourKeys.MedicationChangeModal, true)
  }

  return (
    <>
      <MedicationChangeModal
        onDismiss={handleDismissMedicationModal}
        visible={isMedicationModalVisible}
      />
      <FosterTab
        fosterId={fosterId}
        scrollRef={scrollRef}
        viewId="foster-health-tab"
      >
        <FosterHealthCard
          control={control}
          disabled={isDisabled}
          formState={formState}
          fosterId={fosterId}
          scrollRef={scrollRef}
          setValue={setValue}
        />
      </FosterTab>
    </>
  )
}

export default FosterMedicalTab
